import React from "react";
import { bool, func } from "prop-types";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/images/icons/arrowLeft.svg";
import "./Nav.css";

const LeftNav = React.memo(({
	disabled,
	onClick
}) => {
	return (
		<button
			type="button"
			className="left-nav-button"
			disabled={disabled}
			onClick={onClick}
			aria-label="Previous Slide"
		>
			<ArrowLeftIcon icon="left"  />
		</button>
	);
});

LeftNav.displayName = "LeftNav";

LeftNav.propTypes = {
	disabled: bool.isRequired,
	onClick: func.isRequired
};


export default LeftNav;
